import { defineFetcher } from "~/api/_common/defineFetcher"
import { GET } from "~/api/_common/http"

import { Magazine } from "../_types"

const getPath = (id: number) => `/magazines/${id}`

export const fetchGetMagazinesById = defineFetcher((id: number): Promise<Magazine> => {
  return GET(getPath(id))
})
